var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _linearGradient12, _linearGradient13, _linearGradient14, _linearGradient15, _linearGradient16, _linearGradient17, _linearGradient18, _linearGradient19, _linearGradient20, _linearGradient21, _clipPath, _clipPath2, _clipPath3, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNftavatar3D(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 30,
    viewBox: "0 0 30 30",
    width: 30,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    gradientUnits: "userSpaceOnUse",
    x1: 7.66556,
    x2: 24.5847,
    y1: 5.8338,
    y2: 26.9636
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffa936"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4112,
    stopColor: "#ff8548"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7781,
    stopColor: "#ff6c54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff6359"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    gradientUnits: "userSpaceOnUse",
    x1: 28.8523,
    x2: 27.4372,
    y1: 9.35373,
    y2: 9.66591
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c0272d"
  }))), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    gradientUnits: "userSpaceOnUse",
    x1: 5.30793,
    x2: 27.6626,
    y1: 8.37779,
    y2: 23.651
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cdec7a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2157,
    stopColor: "#b0e995"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5613,
    stopColor: "#87e4bb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8347,
    stopColor: "#6ee1d2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#65e0db"
  }))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "d"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cdec7a",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2354,
    stopColor: "#9ad57d",
    stopOpacity: 0.235
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6035,
    stopColor: "#51b482",
    stopOpacity: 0.604
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8679,
    stopColor: "#239f85",
    stopOpacity: 0.868
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#119786"
  }))), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    gradientUnits: "userSpaceOnUse",
    x1: 28.9225,
    x2: 26.5081,
    xlinkHref: "#d",
    y1: 15.0907,
    y2: 15.0907
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    gradientUnits: "userSpaceOnUse",
    x1: 10.3959,
    x2: 10.3959,
    xlinkHref: "#d",
    y1: 27.4655,
    y2: 26.0352
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    gradientUnits: "userSpaceOnUse",
    x1: 7.76359,
    x2: 26.9029,
    y1: 6.61489,
    y2: 25.7542
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ecf1cd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9a9a9a"
  }))), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    gradientUnits: "userSpaceOnUse",
    x1: 7.92324,
    x2: 30.3142,
    y1: 4.29988,
    y2: 33.806
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a2a2dd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#854286"
  }))), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    gradientUnits: "userSpaceOnUse",
    x1: 14.9455,
    x2: 17.0835,
    y1: 19.9035,
    y2: 24.3944
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8bc727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#02905d"
  }))), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    gradientUnits: "userSpaceOnUse",
    x1: 16.7142,
    x2: 16.7142,
    y1: 23.0364,
    y2: 24.9037
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#026841",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3e5959"
  }))), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "k"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffdfcf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffa78f"
  }))), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    gradientUnits: "userSpaceOnUse",
    x1: 16.7245,
    x2: 16.7044,
    xlinkHref: "#k",
    y1: 19.3562,
    y2: 20.521
  })), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "m"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f89580",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9972,
    stopColor: "#c5715a"
  }))), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "n",
    gradientUnits: "userSpaceOnUse",
    x1: 16.7144,
    x2: 16.7144,
    xlinkHref: "#m",
    y1: 22.265,
    y2: 19.7425
  })), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "o",
    gradientUnits: "userSpaceOnUse",
    x1: 11.2801,
    x2: 12.5521,
    xlinkHref: "#k",
    y1: 13.2701,
    y2: 14.5856
  })), _linearGradient16 || (_linearGradient16 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "p",
    gradientUnits: "userSpaceOnUse",
    x1: 20.4833,
    x2: 22.2634,
    xlinkHref: "#k",
    y1: 13.0284,
    y2: 14.869
  })), _linearGradient17 || (_linearGradient17 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "q",
    gradientUnits: "userSpaceOnUse",
    x1: 13.5365,
    x2: 19.717,
    xlinkHref: "#k",
    y1: 11.9667,
    y2: 16.2632
  })), _linearGradient18 || (_linearGradient18 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "r",
    gradientUnits: "userSpaceOnUse",
    x1: 16.7142,
    x2: 16.7142,
    xlinkHref: "#m",
    y1: 14.8701,
    y2: 16.6659
  })), _linearGradient19 || (_linearGradient19 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "s"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5a5a5a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#444"
  }))), _linearGradient20 || (_linearGradient20 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "t",
    gradientUnits: "userSpaceOnUse",
    x1: 19.3632,
    x2: 21.3975,
    xlinkHref: "#s",
    y1: 9.24892,
    y2: 11.3525
  })), _linearGradient21 || (_linearGradient21 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "u",
    gradientUnits: "userSpaceOnUse",
    x1: 13.4478,
    x2: 16.5064,
    xlinkHref: "#s",
    y1: 7.23567,
    y2: 10.3985
  })), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "v"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h30v30h-30z"
  }))), _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    id: "w"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h30v30h-30z"
  }))), _clipPath3 || (_clipPath3 = /*#__PURE__*/React.createElement("clipPath", {
    id: "x"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h30v30h-30z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#v)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#w)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#x)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m25.1134 27.6789-22.75748-2.5222c-1.09418-.1212-1.882824-1.1065-1.761589-2.2007l2.091709-18.87302c.12129-1.09418 1.10659-1.88288 2.2007-1.76159l22.75746 2.52224c1.0942.12129 1.8829 1.10659 1.7616 2.2007l-2.0917 18.87297c-.1212 1.0942-1.1065 1.8829-2.2007 1.7616z",
    fill: "url(#a)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m29.4058 7.04414-.8247 7.44316-1.8331-9.74316.8966.09929c1.0938.12106 1.8823 1.10624 1.7612 2.20071z",
    fill: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m28.3749 24.1729-22.50212 4.2332c-1.08188.2035-2.12394-.5085-2.32747-1.5904l-3.5105882-18.66125c-.2035298-1.08188.5085292-2.12394 1.5904082-2.32747l22.50217-4.23318c1.0818-.20353 2.1239.50853 2.3274 1.59042l3.5106 18.66128c.2035 1.0819-.5085 2.124-1.5904 2.3274z",
    fill: "url(#c)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26.9351 5.73779v18.70581l1.4397-.2709c1.0819-.2035 1.794-1.2456 1.5904-2.3274z",
    fill: "url(#e)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3.43823 26.2461.10712.5694c.20353 1.0819 1.24559 1.7939 2.32747 1.5904l11.48088-2.1598z",
    fill: "url(#f)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m27.5134 26.4039h-22.89681c-1.10089 0-1.9933-.8924-1.9933-1.9933v-18.98859c0-1.10089.89241-1.9933 1.9933-1.9933h22.89681c1.1008 0 1.9932.89241 1.9932 1.9933v18.98859c0 1.1009-.8924 1.9933-1.9932 1.9933z",
    fill: "url(#g)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m27.9664 26.6126h-23.36116c-1.12316 0-2.03371-.899-2.03371-2.0078v-19.12724c0-1.10887.91055-2.00783 2.03371-2.00783h23.36116c1.1232 0 2.0337.89896 2.0337 2.00783v19.12724c0 1.1088-.9105 2.0078-2.0337 2.0078z",
    fill: "url(#h)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.4218 24.5015h-13.4153c-.31923 0-.57803-.2503-.57803-.559 0-2.9823 2.50003-5.4 5.58403-5.4h3.4034c3.0839 0 5.584 2.4176 5.584 5.4-.0001.3087-.2589.559-.5781.559z",
    fill: "url(#i)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9.42847 23.9424c0 .3087.2588.559.57803.559h13.4153c.3192 0 .578-.2503.578-.559 0-.6704-.1267-1.312-.3575-1.9043h-13.85629c-.23084.5923-.35754 1.234-.35754 1.9043z",
    fill: "url(#j)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16.7144 21.5219c1.0885 0 1.9709-.7224 1.9709-1.6135s-.8824-1.6135-1.9709-1.6135c-1.0886 0-1.971.7224-1.971 1.6135s.8824 1.6135 1.971 1.6135z",
    fill: "url(#l)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16.7144 21.5219c1.0885 0 1.9709-.7224 1.9709-1.6135s-.8824-1.6135-1.9709-1.6135c-1.0886 0-1.971.7224-1.971 1.6135s.8824 1.6135 1.971 1.6135z",
    fill: "url(#n)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10.7986 13.9543c0-.7483.5371-1.3753 1.2589-1.5401.1929-.044.3774.1003.3774.292v2.4963c0 .1917-.1845.336-.3774.2919-.7218-.1648-1.2589-.7917-1.2589-1.5401z",
    fill: "url(#o)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m22.6297 13.9543c0-.7483-.5372-1.3753-1.2589-1.5401-.193-.044-.3774.1003-.3774.292v2.4963c0 .1917.1844.336.3774.2919.7217-.1648 1.2589-.7917 1.2589-1.5401z",
    fill: "url(#p)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16.7141 19.7835c-2.6141 0-4.7331-2.0493-4.7331-4.5773v-2.3472c0-2.5279 2.1191-4.57726 4.7331-4.57726 2.6141 0 4.7332 2.04936 4.7332 4.57726v2.3472c0 2.5279-2.1191 4.5773-4.7332 4.5773z",
    fill: "url(#q)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16.9757 16.3572h-.523c-.4359 0-.7658-.3809-.6895-.7958l.2998-1.6298h1.3023l.2998 1.6298c.0764.415-.2536.7958-.6894.7958z",
    fill: "url(#r)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m22.8769 10.7908c0 .9174-.2648 1.5174-.6287 1.9088-.6866.7385-1.9365.4759-2.3-.4528-.4275-1.0921-1.4374-1.8594-2.6148-1.8594-.0324 0-.0649.0005-.0973.002.1839-1.4807 1.371-2.62329 2.808-2.62329 1.5647-.00006 2.8328 1.3542 2.8328 3.02469z",
    fill: "url(#t)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21.0944 8.27976c-.0458-.61486-.3892-1.17711-.9187-1.5204-.6408-.4154-1.7373-.75936-3.6115-.75936-1.1965 0-2.076.14023-2.7223.3497-.4373.14176-.8786.27244-1.3276.37447-1.4499.32947-2.52529 1.5367-2.52529 2.97583 0 1.6927 1.48769 3.065 3.32289 3.065 1.3499 0 3.681-2.3419 5.758-2.3419.2579 0 .4638-.2176.6996-.3188.5142-.22087 1.4041-.75974 1.3249-1.82454z",
    fill: "url(#u)"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNftavatar3D);
export default __webpack_public_path__ + "static/media/nftavatar_3d.c1ce54f3fcad836e4d722542a17814f2.svg";
export { ForwardRef as ReactComponent };